/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getPovrsinskaStrukturaDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// povrsinskaStrukturaDropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const PovrsinskaStrukturaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [povrsinskaStrukturaDropdown, setPovrsinskaStrukturaDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPovrsinskaStrukturaDropdown()
        setPovrsinskaStrukturaDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching Povrsinska Struktura dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={povrsinskaStrukturaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'povrsinskaStrukturaDropdown'}
      errors={errors}
      placeholder='Odaberi Površinsku Strukturu.'
      touched={touched}
    />
  )
}

export default PovrsinskaStrukturaDropdown
